import React, { useRef } from "react";
import {
  Button,
  Header,
  Icon,
  Modal,
  ModalContent,
  ModalHeader,
  Tab,
} from "semantic-ui-react";

import pollsCss from "../../assets/styles/polls/polls.module.scss";
import css from "../../assets/styles/shared/editor.module.scss";
import BarChart from "./BarChart";
import { CSVLink } from "react-csv";
import { ClipLoader } from "react-spinners";
import moment from "moment-timezone";
import ReportInformation from "./ReportInformation";
import { DownloadIcon } from "../../assets/styles/polls/icons";
import PieChart from "./PieChart";
import GifResult from "./GifResult";

const PollResult = ({
  pollResult,
  showPollResult,
  poll,
  csvData,
  // csvHeaders,
  resultLoading,
}) => {
  const csvLinkRef = useRef(null);
  const csvLinkRef2 = useRef(null);

  const updateCsvData = csvData.filter((data) => !('uid' in data));

  const uidCsvData = csvData.filter((data) => data.uid);

  const keyExists = updateCsvData.some((obj) => "total_response" in obj);


  return (
    <Modal
      onClose={() => showPollResult(false)}
      onOpen={() => showPollResult(true)}
      open={pollResult}
      className={pollsCss.modalContainer}
    >
      {resultLoading ? (
        <div className={pollsCss.resultLoader}>
          <ClipLoader color="#1d84ff" size={25} />
        </div>
      ) : (
        <>
          <ModalContent
            style={{ padding: "0" }}
            className={pollsCss.modalHeader}
          >
            <Header as="h3" style={{ margin: "0" }}>
              {poll?.title}
            </Header>
            <span
              style={{ cursor: "pointer", marginLeft: "20px" }}
              onClick={() => showPollResult(false)}
            >
              <Icon name="close" />
            </span>
          </ModalContent>
          <ModalContent style={{ padding: "0" }}>
            <ReportInformation poll={poll} />
            {poll?.poll_type === "multiple-choice" &&
              poll?.template_data?.variant === "text" && (
                <BarChart pollResponse={csvData} isMultipleChoice={true} />
              )}
            {poll?.poll_type === "yes-no" && (
              <PieChart pollResponse={csvData} />
            )}
            {poll?.poll_type === "rating" && (
              <BarChart pollResponse={csvData} isMultipleChoice={false} />
            )}
            {poll?.poll_type === "multiple-choice" &&
              poll?.template_data?.variant === "gif" && (
                <GifResult pollResponse={csvData} />
              )}

            <div className={pollsCss.resultButton}>
              {uidCsvData && uidCsvData?.length > 0 && (
                <Button
                  onClick={() => {
                    csvLinkRef2.current?.link?.click();
                  }}
                  className={css?.primaryButton}
                >
                  <DownloadIcon /> Summary report (CSV)
                </Button>
              )}
              <Button
                onClick={() => {
                  csvLinkRef.current?.link?.click();
                }}
                className={css?.primaryButton}
              >
                <DownloadIcon /> Full report (CSV)
              </Button>
            </div>
          </ModalContent>
        </>
      )}

      <CSVLink
        data={updateCsvData}
        headers={[
          { label: "Option", key: "option_text" },
          {
            label: "Answer",
            key: keyExists ? "total_response" : "response_count",
          },
        ]}
        filename={`${poll.title}-poll-responses.csv`}
        className="hidden"
        ref={csvLinkRef}
      />
      {uidCsvData.length > 0 && (
        <CSVLink
          data={uidCsvData}
          headers={[
            { label: "UID", key: "uid" },
            { label: "Answer", key: "option_text" },
          ]}
          filename={`${poll.title}-uid-poll-responses.csv`}
          className="hidden"
          ref={csvLinkRef2}
        />
      )}
    </Modal>
  );
};

export default PollResult;
